module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "dialog-class": "cardRounded relative",
      "body-class": _vm.modalVisible,
      "open": _vm.showModal
    },
    on: {
      "close": _vm.toggleVisibility
    }
  }, [_c('div', {
    staticClass: "outerWrap"
  }, [(!_vm.saved && !_vm.rejected) ? _c('div', {
    staticClass: "contentWrap"
  }, [_c('button', {
    staticClass: "transparent close"
  }, [_c('mu-icon', {
    staticClass: "closeIcon",
    attrs: {
      "value": "close"
    },
    on: {
      "click": _vm.toggleVisibility
    }
  })], 1), _vm._v(" "), _c('mu-card-text', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.usernameInitialModalTitle')))]), _vm._v(" "), _c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.usernameInitialModalBody')) + "\n      ")]), _vm._v(" "), _c('mu-card-text', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "full-width": "",
      "hint-text": "Max. 30 characters",
      "label": "Desired Username",
      "data-vv-rules": 'display_name_regex|min:2|max:30',
      "data-vv-name": "displayName",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDisplayName'),
      "errorText": _vm.errors.first('displayName'),
      "fullWidth": true,
      "label": _vm.$t('message.accountPreferencesDisplayName')
    },
    model: {
      value: (_vm.displayName),
      callback: function($$v) {
        _vm.displayName = $$v
      },
      expression: "displayName"
    }
  })], 1), _vm._v(" "), _c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.usernameInitialModalTip')) + "\n      ")]), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    staticClass: "spaceBelow"
  }, [_c('mu-flat-button', {
    staticClass: "fullWidth halfRounded btnPrimary btnAction",
    attrs: {
      "primary": true,
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.accept
    }
  }, [_vm._v("\n            " + _vm._s(_vm.saving ? _vm.$t('message.savingText') : _vm.$t('message.usernameInitialModalSave')) + "\n          ")])], 1), _vm._v(" "), _c('mu-row', [_c('mu-flat-button', {
    staticClass: "fullWidth halfRounded btnSecondary btnAction",
    attrs: {
      "secondary": true
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v(_vm._s(_vm.$t('message.usernameInitialModalReject')) + "\n          ")])], 1)], 1)], 1) : (_vm.saved) ? _c('div', {
    staticClass: "contentWrap"
  }, [_c('mu-card-text', {
    staticClass: "title"
  }, [_c('mu-icon', {
    staticClass: "circleCheck",
    attrs: {
      "value": "check"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.usernameInitialModalConfirmTitle')) + "\n      ")], 1), _vm._v(" "), _c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.usernameInitialModalConfirmBody')) + "\n      ")]), _vm._v(" "), _c('mu-card-text', [_c('mu-flat-button', {
    staticClass: "fullWidth halfRounded btnPrimary btnAction",
    attrs: {
      "primary": true
    },
    on: {
      "click": _vm.toggleVisibility
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelContinueText')) + "\n        ")])], 1)], 1) : (_vm.rejected) ? _c('div', {
    staticClass: "contentWrap"
  }, [_c('mu-card-text', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.usernameInitialModalRejectTitle')))]), _vm._v(" "), _c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.usernameInitialModalRejectBody')) + "\n      ")]), _vm._v(" "), _c('mu-card-text', [_c('mu-flat-button', {
    staticClass: "fullWidth halfRounded btnPrimary btnAction",
    attrs: {
      "primary": true
    },
    on: {
      "click": _vm.toggleVisibility
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelContinueText')) + "\n        ")])], 1)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a4c67c4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/DisplayNameModal.vue
// module id = 3035
// module chunks = 1